import { render } from "./App.vue?vue&type=template&id=617ab0be&ts=true"
import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=617ab0be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "617ab0be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('617ab0be', __exports__)) {
    api.reload('617ab0be', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=617ab0be&ts=true", () => {
    api.rerender('617ab0be', render)
  })

}


export default __exports__